import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupportComponent } from './support.component';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [SupportComponent],
  exports: [
    SupportComponent
  ]
})
export class SupportModule { }



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/support/support.module.ts